import { h4 } from '@/layout/styles/Typography';
import { px } from '@/layout/styles/classes';
import { ReactComponent as FDAIcon } from '@a/images/home/benefits/fda.svg';
import { ReactComponent as GMOIcon } from '@a/images/home/benefits/gmo.svg';
import { ReactComponent as USIcon } from '@a/images/home/benefits/us.svg';
import { ReactComponent as VeganIcon } from '@a/images/home/benefits/vegan.svg';
import styled from '@emotion/styled';

const Section = styled.section`
    ${px};
    padding-top: 16px;
    padding-bottom: 32px;

    @media (min-width: 1024px) {
        padding-top: 32px;
        padding-bottom: 32px;
        background-image: linear-gradient(180deg, #dcf6fc 0, #dcf6fc 64px, white 64px, white);
    }

    @media (min-width: 1280px) {
        padding-top: 64px;
        padding-bottom: 64px;
        background-image: linear-gradient(180deg, #dcf6fc 0, #dcf6fc 130px, white 130px, white);
    }
`;
const Box = styled.div`
    padding: 8px;
    border-radius: 32px;
    background-color: ${({ theme }) => theme.colors.blue7};
    display: flex;
    overflow-x: auto;
    align-items: flex-start;
    gap: 16px;
    max-width: 1312px;
    margin: 0 auto;
    box-shadow: 0px 6px 10px 0px rgba(121, 99, 104, 0.14);

    @media (min-width: 1024px) {
        padding: 0 8px 40px;
        justify-content: center;
        overflow-x: unset;
        flex-wrap: wrap;
        gap: 32px;
    }

    @media (min-width: 1280px) {
        gap: 64px;
    }
`;

const Benefit = styled.div`
    text-align: center;
    width: 192px;
    flex-shrink: 0;

    > svg {
        width: 32px;
        height: 32px;
        margin: 0 auto;
    }

    > p {
        :first-of-type {
            ${h4};
            color: ${({ theme }) => theme.colors.white};
            margin: 16px 0;
        }

        :last-of-type {
            color: ${({ theme }) => theme.colors.gray2};
            margin: 0;
        }
    }

    @media (min-width: 768px) {
        width: 220px;
    }

    @media (min-width: 1024px) {
        width: 260px;

        :not(:last-of-type) {
            margin-top: -32px;
        }

        > svg {
            width: 64px;
            height: 64px;
        }
    }

    @media (min-width: 1280px) {
        width: 316px;

        :not(:last-of-type) {
            margin-top: -66px;
        }

        > svg {
            width: 130px;
            height: 130px;
        }
    }
`;

export const Benefits = () => {
    return (
        <Section>
            <Box>
                <Benefit>
                    <FDAIcon />
                    <p>FDA Registered</p>
                    <p>HACCP approved and are Registered with the FDA.</p>
                </Benefit>
                <Benefit>
                    <VeganIcon />
                    <p>Vegan</p>
                    <p>All Our Products are 100% Vegan and no mineral is sourced from animals</p>
                </Benefit>
                <Benefit>
                    <USIcon />
                    <p>Made in US</p>
                    <p>All Products made and bottled in the United States.</p>
                </Benefit>
                <Benefit>
                    <GMOIcon />
                    <p>GMO free</p>
                    <p>All our products are GMO Free.</p>
                </Benefit>
            </Box>
        </Section>
    );
};
